import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormaDePagamento} from "../../pedidos/objetos/FormaDePagamento";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {NgForm} from "@angular/forms";
import {FormasDePagamentoService} from "../../services/formas-de-pagamento.service";
import {NumerosWhatsappService} from "../../services/numeros-whatsapp.service";
import {NumeroWhatsapp} from "../../pedidos/objetos/NumeroWhatsapp";
import {WhatsappV4Service} from "../../services/whatsapp-v4.service";

@Component({
  selector: 'app-novo-numero-whatsapp',
  templateUrl: './novo-numero-whatsapp.component.html',
  styleUrls: ['./novo-numero-whatsapp.component.scss']
})
export class NovoNumeroWhatsappComponent implements OnInit {
  numeroWhatsapp: NumeroWhatsapp;
  windowRef: DialogRef;
  empresa: any;
  podeAlterarVersao = false;
  mensagemErro = '';
  telefoneFormatado: string = '';
  @ViewChild('frm',  {static: false} ) frm: NgForm;
  enviando = false;
  carregandoPolitica = false;
  politicaCarregada = false;
  abaAtiva = 0;
  /** Versão que está salva no servidor, para saber se o admin está trocando. */
  versaoExtensaoSalva: number = null;
  assuntos = ['Número e extensão', 'Limites de marketing', 'Mensagens de pedidos'];
  limitesSugeridos = [25, 50, 100, 150];
  horas = Array.from({length: 24}, (_, hora) => hora);
  @ViewChild('conteudo') conteudo: ElementRef<HTMLElement>;

  selecioneAba(aba: number) {
    if (this.enviando) return;
    this.abaAtiva = aba;
    if (this.conteudo) {
      this.conteudo.nativeElement.scrollTop = 0;
      const formulario = this.conteudo.nativeElement.closest('form');
      const botao = formulario.querySelector<HTMLButtonElement>('#aba-whatsapp-' + aba);
      if (botao) botao.focus();
    }
  }

  navegueAbas(evento: KeyboardEvent, aba: number) {
    const destinos = {ArrowRight: (aba + 1) % 3, ArrowLeft: (aba + 2) % 3, Home: 0, End: 2};
    if (destinos[evento.key] !== undefined) {
      evento.preventDefault();
      this.selecioneAba(destinos[evento.key]);
    }
  }

  private valideAba(aba: number): boolean {
    const campos = [['whatsapp'], ['limiteDiario', 'janelaInicioHora', 'janelaFimHora'],
      ['intervaloStatusPedidoSegundos']][aba];
    const invalido = campos.find(nome => {
      const controle = this.frm.controls[nome];
      return controle && controle.invalid;
    });
    if (!invalido) return true;
    this.frm.controls[invalido].markAsTouched();
    this.selecioneAba(aba);
    setTimeout(() => {
      const campo = this.conteudo.nativeElement.querySelector<HTMLElement>('#' + invalido);
      if (campo) campo.focus();
    });
    return false;
  }

  continuarOuSalvar() {
    if (this.enviando || !this.politicaCarregada) return;
    if (this.numeroWhatsapp.versaoExtensao === 4 && this.abaAtiva < 2) {
      if (this.valideAba(this.abaAtiva)) this.selecioneAba(this.abaAtiva + 1);
      return;
    }
    this.onSalvar();
  }

  get resumoHorario(): string {
    if (this.duracaoDaJanelaHoras === 24) return 'durante as 24 horas';
    return 'das ' + this.horaInicioFormatada + 'h às ' + this.horaFimFormatada + 'h' +
      (this.numeroWhatsapp.janelaFimHora < this.numeroWhatsapp.janelaInicioHora ? ' do dia seguinte' : '');
  }

  /** Torna o ritmo diário tangível: com o limite atual, quantos dias uma lista
   *  de mil contatos leva para terminar. É o efeito prático de escolher 25 ou
   *  150 — a campanha não é cortada, ela se estende. */
  get nomeExtensaoEscolhida(): string {
    return Number(this.numeroWhatsapp.versaoExtensao) === 4 ? 'nova extensão' : 'extensão padrão';
  }

  get nomeExtensaoSalva(): string {
    return Number(this.versaoExtensaoSalva) === 4 ? 'nova extensão' : 'extensão padrão';
  }

  /** Só em número já existente: em número novo não há "extensão de hoje" para trocar. */
  get trocandoExtensao(): boolean {
    return !!this.numeroWhatsapp.id && !!this.versaoExtensaoSalva &&
      Number(this.numeroWhatsapp.versaoExtensao) !== Number(this.versaoExtensaoSalva);
  }

  get diasDaListaDeExemplo(): number {
    const limite = Number(this.numeroWhatsapp.limiteDiario);
    if (!limite || limite <= 0) return 0;
    return Math.ceil(1000 / limite);
  }

  constructor(private dialogService: DialogService, private numerosWhatsappService: NumerosWhatsappService,
              private whatsappV4Service: WhatsappV4Service) {
    this.numeroWhatsapp = new NumeroWhatsapp();
  }

  ngOnInit(): void {
    // Se estiver editando, formatar o telefone existente
    if (this.numeroWhatsapp.whatsapp) {
      this.telefoneFormatado = this.formatarTelefone(this.numeroWhatsapp.whatsapp);
    }
  }

  carreguePolitica() {
    if (this.numeroWhatsapp.whatsapp) {
      this.telefoneFormatado = this.formatarTelefone(this.numeroWhatsapp.whatsapp);
    }

    this.carregandoPolitica = true;
    this.politicaCarregada = false;

    this.whatsappV4Service.obtenhaPolitica(this.empresa, this.numeroWhatsapp).then((resposta: any) => {
      const politica = resposta.politicaEfetiva;
      const resumoHoje = resposta.resumoHoje || {};

      this.numeroWhatsapp.versaoExtensao = Number(resposta.versaoExtensao) || 3;
      this.versaoExtensaoSalva = this.numeroWhatsapp.versaoExtensao;
      this.numeroWhatsapp.limiteDiario = politica.limiteDiario;
      this.numeroWhatsapp.intervaloEnvioSegundos = politica.intervaloEnvioSegundos;
      this.numeroWhatsapp.intervaloMinimoSegundos = politica.intervaloMinimoSegundos;
      this.numeroWhatsapp.limitePorHoraCalculado = politica.limitePorHoraCalculado;
      this.numeroWhatsapp.intervaloCampanhaSegundos = politica.intervaloCampanhaSegundos;
      this.numeroWhatsapp.intervaloAutomacaoSegundos = politica.intervaloAutomacaoSegundos;
      this.numeroWhatsapp.intervaloStatusPedidoSegundos = politica.intervaloStatusPedidoSegundos;
      this.numeroWhatsapp.aplicarIntervaloConfirmacaoLoja = !!politica.aplicarIntervaloConfirmacaoLoja;
      this.numeroWhatsapp.intervaloAvaliacaoSegundos = politica.intervaloAvaliacaoSegundos;
      this.numeroWhatsapp.intervaloGlobalAutomaticoSegundos = politica.intervaloGlobalAutomaticoSegundos;
      this.numeroWhatsapp.limiteAutomacaoPorHora = politica.limiteAutomacaoPorHora;
      this.numeroWhatsapp.limiteCampanhaPorHora = politica.limiteCampanhaPorHora;
      this.numeroWhatsapp.duracaoMinimaCampanhaHoras = politica.duracaoMinimaCampanhaHoras;
      this.numeroWhatsapp.capacidadeDiariaCalculada = politica.capacidadeDiariaCalculada;
      this.numeroWhatsapp.duracaoDaJanelaHoras = politica.duracaoDaJanelaHoras;
      this.numeroWhatsapp.janelaInicioHora = politica.janelaInicioHora;
      this.numeroWhatsapp.janelaFimHora = politica.janelaFimHora;
      this.numeroWhatsapp.pausado = politica.pausado;
      this.numeroWhatsapp.usadoHoje = resumoHoje.usadoHoje;
      this.numeroWhatsapp.restanteHoje = resumoHoje.restanteHoje;
      this.numeroWhatsapp.proximoEnvioEmMs = resumoHoje.proximoEnvioEmMs;
      this.numeroWhatsapp.incertasHoje = resumoHoje.incertasHoje;
      this.politicaCarregada = true;
      this.carregandoPolitica = false;
    }).catch((erro) => {
      this.mensagemErro = erro;
      this.carregandoPolitica = false;
    });
  }

  async onSalvar() {
    delete this.mensagemErro;

    if (this.enviando || !this.politicaCarregada || !this.valideAba(0)) return;
    if (this.numeroWhatsapp.versaoExtensao === 4 && (!this.valideAba(1) || !this.valideAba(2))) return;

    if(!this.frm.valid){
      return;
    }

    this.ajusteLimiteAJanela();

    // Garantir que o telefone está limpo antes de salvar
    this.numeroWhatsapp.whatsapp = this.limparTelefone(this.telefoneFormatado);

    this.enviando = true;

    try {
      const resposta = await this.numerosWhatsappService.salveNumeroWhatsapp(this.numeroWhatsapp, this.empresa);

      this.numeroWhatsapp.id = resposta.id;
      await this.whatsappV4Service.salvePolitica(this.empresa, this.numeroWhatsapp);
      this.windowRef.close();
      this.enviando = false;
    } catch (erro) {
      this.mensagemErro = erro;
      this.enviando = false;
    }
  }

  remova() {

  }

  fechar() {
    this.windowRef.close();
  }

  // Métodos de validação e formatação de telefone
  onTelefoneInput(event: any) {
    const value = event.target.value;
    const numeroLimpo = this.limparTelefone(value);

    // Aplica máscara dinâmica baseada no tamanho
    this.telefoneFormatado = this.aplicarMascaraDinamica(numeroLimpo);

    // Atualiza o valor no campo
    event.target.value = this.telefoneFormatado;

    // Remove formatação para salvar apenas números
    this.numeroWhatsapp.whatsapp = numeroLimpo;
  }

  onTelefoneBlur() {
    // Reaplica a formatação final
    if (this.telefoneFormatado) {
      const numeroLimpo = this.limparTelefone(this.telefoneFormatado);
      this.telefoneFormatado = this.aplicarMascaraDinamica(numeroLimpo);
      this.numeroWhatsapp.whatsapp = numeroLimpo;
    }
  }

  limparTelefone(telefone: string): string {
    if (!telefone) return '';
    // Remove todos os caracteres não numéricos
    return telefone.replace(/\D/g, '');
  }

  aplicarMascaraDinamica(numeroLimpo: string): string {
    if (!numeroLimpo) return '';

    // Limita a 11 dígitos
    if (numeroLimpo.length > 11) {
      numeroLimpo = numeroLimpo.substring(0, 11);
    }

    // Aplica formatação baseada no tamanho
    if (numeroLimpo.length <= 2) {
      return `(${numeroLimpo}`;
    } else if (numeroLimpo.length <= 6) {
      return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2)}`;
    } else if (numeroLimpo.length <= 10) {
      // Formato fixo: (XX) XXXX-XXXX
      return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 6)}-${numeroLimpo.substring(6)}`;
    } else {
      // Formato celular: (XX) XXXXX-XXXX
      return `(${numeroLimpo.substring(0, 2)}) ${numeroLimpo.substring(2, 7)}-${numeroLimpo.substring(7)}`;
    }
  }

  formatarTelefone(telefone: string): string {
    if (!telefone) return '';
    const numeroLimpo = telefone.replace(/\D/g, '');
    return this.aplicarMascaraDinamica(numeroLimpo);
  }

  validarTelefone(telefone: string): boolean {
    if (!telefone) return false;
    const telefoneLimpo = this.limparTelefone(telefone);

    // Validação para telefone brasileiro: aceita fixo (10 dígitos) e celular (11 dígitos)
    // Fixo: [1-9]{2}[2-5][0-9]{7} - DDD + número fixo (8 dígitos começando com 2-5)
    // Celular: [1-9]{2}9[6-9][0-9]{7} - DDD + 9 + número celular (8 dígitos começando com 6-9)
    const regexFixo = /^[1-9]{2}[2-5][0-9]{7}$/;
    const regexCelular = /^[1-9]{2}9[6-9][0-9]{7}$/;

    return regexFixo.test(telefoneLimpo) || regexCelular.test(telefoneLimpo);
  }

  get intervaloCalculadoSegundos(): number {
    const minimo = Math.max(10, Number(this.numeroWhatsapp.intervaloMinimoSegundos) || 60);
    const limitePorHora = Math.max(1, Number(this.numeroWhatsapp.limiteCampanhaPorHora) || 20);
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const duracaoMinimaHoras = Math.max(1, Number(this.numeroWhatsapp.duracaoMinimaCampanhaHoras) || 4);
    const peloTetoHorario = Math.ceil(60 * 60 / limitePorHora);
    const pelaDuracaoMinima = Math.ceil(duracaoMinimaHoras * 60 * 60 / limiteDiario);

    return Math.max(minimo, peloTetoHorario, pelaDuracaoMinima);
  }

  get intervaloAutomacaoCalculadoSegundos(): number {
    const minimo = Math.max(10, Number(this.numeroWhatsapp.intervaloMinimoSegundos) || 60);
    const limitePorHora = Math.max(1, Number(this.numeroWhatsapp.limiteAutomacaoPorHora) || 8);
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const pelaJanela = Math.ceil(this.duracaoDaJanelaHoras * 60 * 60 / limiteDiario);

    return Math.max(minimo, Math.ceil(60 * 60 / limitePorHora), pelaJanela);
  }

  get intervaloPedidosCalculadoSegundos(): number {
    return Math.max(
      Number(this.numeroWhatsapp.intervaloStatusPedidoSegundos) || 30,
      Number(this.numeroWhatsapp.intervaloGlobalAutomaticoSegundos) || 30
    );
  }

  get limiteMaximoSlider(): number {
    return 150;
  }

  definaLimiteDiario(valor: number) {
    const valorInformado = Number(valor) || 0;

    if (valorInformado <= 0) {
      this.numeroWhatsapp.pausado = true;
      return;
    }

    const limite = Math.max(
      10,
      Math.min(this.limiteMaximoSlider, Math.round(valorInformado / 5) * 5)
    );

    this.numeroWhatsapp.limiteDiario = limite;
    this.numeroWhatsapp.pausado = false;
  }

  ajusteLimiteAJanela() {
    const limite = Number(this.numeroWhatsapp.limiteDiario);

    if (!Number.isFinite(limite)) {
      return;
    }

    this.numeroWhatsapp.limiteDiario = Math.max(
      10,
      Math.min(this.limiteMaximoSlider, Math.trunc(limite))
    );
  }

  get duracaoDaJanelaHoras(): number {
    const inicio = Number(this.numeroWhatsapp.janelaInicioHora);
    const fim = Number(this.numeroWhatsapp.janelaFimHora);

    if (!Number.isFinite(inicio) || !Number.isFinite(fim)) {
      return 0;
    }

    if (inicio === fim) {
      return 24;
    }

    return (fim - inicio + 24) % 24;
  }

  get limitePorHoraCalculado(): number {
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);

    return Math.max(1, Math.min(limiteDiario, Math.ceil(60 * 60 / this.intervaloCalculadoSegundos)));
  }

  get horaInicioFormatada(): string {
    const hora = Math.max(0, Math.min(23, Number(this.numeroWhatsapp.janelaInicioHora) || 0));

    return ('0' + hora).slice(-2);
  }

  get horaFimFormatada(): string {
    const hora = Math.max(0, Math.min(23, Number(this.numeroWhatsapp.janelaFimHora) || 0));

    return ('0' + hora).slice(-2);
  }

  get usadoHojeExibicao(): string {
    if (this.numeroWhatsapp.usadoHoje == null) return '—';
    const usadoHoje = Number(this.numeroWhatsapp.usadoHoje);

    return Number.isFinite(usadoHoje) && usadoHoje >= 0 ? String(usadoHoje) : '—';
  }

  get restanteHojeCalculado(): number {
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const restanteHoje = Number(this.numeroWhatsapp.restanteHoje);

    if (Number.isFinite(restanteHoje) && restanteHoje >= 0) {
      return Math.min(limiteDiario, restanteHoje);
    }

    const usadoHoje = Number(this.numeroWhatsapp.usadoHoje);
    if (Number.isFinite(usadoHoje) && usadoHoje >= 0) {
      return Math.max(0, limiteDiario - usadoHoje);
    }

    return limiteDiario;
  }

  get percentualUsadoHoje(): number {
    const limiteDiario = Math.max(10, Number(this.numeroWhatsapp.limiteDiario) || 10);
    const usadoHoje = Number(this.numeroWhatsapp.usadoHoje);

    if (!Number.isFinite(usadoHoje) || usadoHoje < 0) {
      return 0;
    }

    return Math.min(100, Math.round(usadoHoje / limiteDiario * 100));
  }

  formateDuracao(segundos: number): string {
    const total = Math.max(0, Math.ceil(Number(segundos) || 0));
    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);
    const segundosRestantes = total % 60;
    const partes: string[] = [];

    if (horas) {
      partes.push(horas + 'h');
    }
    if (minutos) {
      partes.push(minutos + 'min');
    }
    if (segundosRestantes && !horas) {
      partes.push(segundosRestantes + 's');
    }

    return partes.length ? partes.join(' ') : 'agora';
  }
}
